import * as React from 'react';
import {
  Label,
  ArticleHeading2,
  ArticleParagraph1,
  useDeviceType,
  ArticleHeading3,
  ArticleParagraph2,
} from '@cian/ui-kit';

import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './PromoCompilationItem.css';
import { ICompilation } from '../../../../types/promosPage';

interface IPromoCompilationItemProps {
  compilation: ICompilation;
  background: string;
  ref?: React.Ref<HTMLAnchorElement>;
  onClick?(): void;
}

const MAX_ICONS = 6;

export const PromoCompilationItem: React.FC<IPromoCompilationItemProps> = props => {
  const { compilation, background, ref, onClick } = props;
  const { label, title, description, providers, url } = compilation;
  const iconProviders = providers.slice(0, MAX_ICONS);

  const isDesktop = useDeviceType() === 'desktop';
  const Heading = isDesktop ? ArticleHeading2 : ArticleHeading3;
  const Paragraph = isDesktop ? ArticleParagraph1 : ArticleParagraph2;

  return (
    <a
      href={url}
      rel={'noreferrer'}
      target={'_blank'}
      title={title}
      className={styles['container']}
      style={{ background }}
      ref={ref}
      onClick={onClick}
    >
      <div className={styles['label-wrapper']}>
        <Label background="theme-white" color="theme-dark">
          {label}
        </Label>
      </div>
      <div className={styles['heading-wrapper']}>
        <Heading>{title}</Heading>
      </div>
      <div className={styles['text-wrapper']}>
        <Paragraph>{description}</Paragraph>
      </div>
      <div className={styles['bottom']}>
        <div className={styles['providers']}>
          {iconProviders.map(provider => (
            <div
              key={provider.id}
              className={styles['provider-icon']}
              style={{ backgroundImage: `url("${provider.logoUrl}")` }}
              data-testid="CompilationItemProviderIcon"
            />
          ))}
        </div>
        <div className={styles['arrow-button']}>
          <IconActionArrowRight16 color="icon-main-default" />
        </div>
      </div>
    </a>
  );
};
